import {
  pgTable, uuid, text, timestamp, integer, boolean, jsonb, index,
} from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// Health Score System (S.6)
// ---------------------------------------------------------------------------
// Configurable multi-dimensional health scoring per contact.
// healthScoreHistory is APPEND-ONLY — one row per computation for trend charts.

export interface HealthDimension {
  name: string;
  source: string; // "engagement_profile" | "revenue" | "satisfaction" | "delivery" | "communication"
  weight: number; // 0.0-1.0, all dimensions sum to 1.0
}

export interface HealthThresholds {
  green: number; // score >= green = healthy
  yellow: number; // score >= yellow = at-risk
  // score < yellow = unhealthy (red)
}

export const healthScoreConfigs = pgTable("health_score_configs", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  name: text("name").notNull(),
  dimensions: jsonb("dimensions").$type<HealthDimension[]>().notNull(),
  thresholds: jsonb("thresholds").$type<HealthThresholds>().notNull(),
  appliesToSegmentId: uuid("applies_to_segment_id"), // null = default for all
  isDefault: boolean("is_default").notNull().default(false),
  createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
}, (table) => [
  index("idx_health_config_tenant").on(table.tenantId),
]);

export const healthScoreHistory = pgTable("health_score_history", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  personId: uuid("person_id").notNull(),
  configId: uuid("config_id").notNull(),
  compositeScore: integer("composite_score").notNull(), // 0-100
  dimensionScores: jsonb("dimension_scores").$type<Record<string, number>>().notNull(),
  computedAt: timestamp("computed_at", tz).notNull().defaultNow(),
  // No updatedAt — append-only for trend charts
}, (table) => [
  index("idx_health_history_person").on(table.tenantId, table.personId),
  index("idx_health_history_computed").on(table.tenantId, table.computedAt),
]);
